import cycleAnalyticsAppBundle from 'ee_else_ce/analytics/cycle_analytics/bundle';

cycleAnalyticsAppBundle();
